var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousekeepingFloorDirty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.625H5.25C4.95163 2.625 4.66548 2.74353 4.4545 2.9545C4.24353 3.16548 4.125 3.45163 4.125 3.75V20.25C4.125 20.5484 4.24353 20.8345 4.4545 21.0455C4.66548 21.2565 4.95163 21.375 5.25 21.375H18.75C19.0484 21.375 19.3345 21.2565 19.5455 21.0455C19.7565 20.8345 19.875 20.5484 19.875 20.25V3.75C19.875 3.45163 19.7565 3.16548 19.5455 2.9545C19.3345 2.74353 19.0484 2.625 18.75 2.625ZM14.25 13.125H19.125V16.125H10.125V13.125H14.25ZM14.625 12.375V9.375H19.125V12.375H14.625ZM5.25 3.375H18.75C18.8495 3.375 18.9448 3.41451 19.0152 3.48484C19.0855 3.55516 19.125 3.65054 19.125 3.75V8.625H14.25C14.1505 8.625 14.0552 8.66451 13.9848 8.73483C13.9145 8.80516 13.875 8.90054 13.875 9V12.375H9.75C9.65054 12.375 9.55516 12.4145 9.48483 12.4848C9.41451 12.5552 9.375 12.6505 9.375 12.75V16.125H4.875V3.75C4.875 3.65054 4.91451 3.55516 4.98484 3.48484C5.05516 3.41451 5.15054 3.375 5.25 3.375ZM18.75 20.625H5.25C5.15054 20.625 5.05516 20.5855 4.98484 20.5152C4.91451 20.4448 4.875 20.3495 4.875 20.25V16.875H19.125V20.25C19.125 20.3495 19.0855 20.4448 19.0152 20.5152C18.9448 20.5855 18.8495 20.625 18.75 20.625Z",
    fill: "url(#paint0_linear_1034_9135)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1034_9135",
    x1: 12,
    y1: 2.625,
    x2: 12,
    y2: 21.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeepingFloorDirty);
export default __webpack_public_path__ + "static/media/housekeeping_floor_dirty.64478ee3753c163a219733dd4b32609a.svg";
export { ForwardRef as ReactComponent };